import { SpeedRate } from "@types";
import { toFarsiNumber } from "@utils/digits";
import { FC, ChangeEvent, useEffect, useRef } from "react";

interface Props {
  min: number;
  max: number;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: SpeedRate) => void;
  value: SpeedRate;
}

const MenuRangeSlider: FC<Props> = ({ min, max, onChange, value }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.setProperty(
        "--value",
        ((Number(value) - Number(min)) / (Number(max) - Number(min))) * 100 +
          "%"
      );
    }
  }, [value, min, max, inputRef]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.target.style.setProperty(
      "--value",
      ((Number(e.target.value) - Number(e.target.min)) /
        (Number(e.target.max) - Number(e.target.min))) *
        100 +
        "%"
    );
    onChange(Number(e.target.value) as SpeedRate);
  };

  return (
    <div className="px-3.5   py-2.5 w-full">
      <p className="text-xs text-fds-secondary mb-3  text-right" dir="rtl">
        سرعت پخش: <span>{toFarsiNumber(value) + "x"}</span>
      </p>

      <input
        ref={inputRef}
        type="range"
        min={min}
        max={max}
        step={0.25}
        value={value}
        onChange={handleInputChange}
        className="slider"
      />

      <div className="flex text-xs justify-between text-right text-fds-secondary mt-2  px-2">
        <span>۰.۷۵x</span>
        <span>۲x</span>
      </div>
    </div>
  );
};

export default MenuRangeSlider;
